import evervizTheme from '../../../editor/meta/highed.meta.everviz.theme';
import DefaultData from '../../ChartEditorPage/meta/data/DefaultData';

export default {
  aggregatedOptions: {
    ...evervizTheme,
    stockTools: {
      gui: {
        enabled: false
      }
    },
    data: {
      csv: DefaultData.line.data,
      seriesMapping: DefaultData.line.seriesMapping
    }
  },
  templateOptions: [],
  themeOptions: {
    options: {},
    id: null
  },
  themeMeta: {
    isevervizTheme: true
  },
  customizedOptions: {
    title: {
      enabled: true
    }
  },
  cssModules: [],
  lastSaved: false,
  dataOptions: [],
  dataConfig: { googleSpreadsheetKey: '' },
  seriesAssigns: [],
  projectName: '',
  plugins: {},
  templateMeta: [],
  saved: false,
  published: false,
  publishLoading: false,
  embedDetails: {},
  uuid: false,
  changeMade: true,
  useDefaultData: null,
  toggleInspired: false,
  showUnsavedChangesModal: false,
  showUnpublishModal: false,
  richtextGroupOptions: null,
  templateDataSettings: {},
  tab: 'customize',
  pluginConfig: {},
  deletedSeries: [],
  activeColumns: {
    columns: [],
    series: []
  },
  lastPublishTime: false,
  isPastingActive: false,
  activeSection: 'basic',
  activeBasicTab: ''
};
